import script from "./ResourceDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ResourceDetailView.vue?vue&type=style&index=0&id=634613ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634613ea"]])

export default __exports__